import { render, staticRenderFns } from "./PeriodPicker.vue?vue&type=template&id=845bc0de&scoped=true"
import script from "./PeriodPicker.vue?vue&type=script&lang=js"
export * from "./PeriodPicker.vue?vue&type=script&lang=js"
import style0 from "./PeriodPicker.vue?vue&type=style&index=0&id=845bc0de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "845bc0de",
  null
  
)

export default component.exports